import { useAdminApi } from "../lib/api";
import { useI18n } from "../i18n";

interface EmailRow {
  id: string;
  template: string;
  recipient: string;
  subject: string;
  status: string;
  providerId: string | null;
  error: string | null;
  createdAt: string;
}

/**
 * 寄信紀錄
 * ---------------------------------------------------------------
 * 「我沒收到信」是客服最常見的問題。這一頁存在的唯一目的
 * 就是能回答它：我們寄了沒、Resend 收下了沒、失敗的話錯誤是什麼。
 */
export default function Emails() {
  const { t, locale } = useI18n();
  const { data, loading, error } = useAdminApi<EmailRow[]>("/emails?limit=100");

  if (loading) return <div className="h-96 rounded-card shimmer" />;
  if (error) return <p className="rounded-card nm-inset p-6 text-sm text-brand-300">{error}</p>;

  return (
    <div className="rounded-card nm p-5">
      <h2 className="mb-4 text-sm font-semibold text-ink">{t("emails.title")}</h2>

      {(data ?? []).length === 0 ? (
        <p className="text-sm text-ink-muted">{t("emails.empty")}</p>
      ) : (
        <div className="space-y-2.5">
          {(data ?? []).map((row) => (
            <div key={row.id} className="rounded-2xl nm-inset-sm p-4">
              <div className="flex flex-wrap items-center justify-between gap-2">
                <span className="text-sm font-medium text-ink">{row.subject}</span>
                <span
                  className={
                    "rounded-pill px-2.5 py-1 text-[11px] font-medium " +
                    (row.status === "sent"
                      ? "nm-sm text-ink-soft"
                      : "bg-brand-600/26 text-brand-100")
                  }
                >
                  {row.status === "sent" ? t("emails.sent") : t("emails.failed")}
                </span>
              </div>

              <p className="mt-1.5 flex flex-wrap gap-x-4 gap-y-1 text-[11px] text-ink-muted">
                <span>{row.recipient}</span>
                <span>{row.template}</span>
                <span>{new Date(row.createdAt).toLocaleString(locale)}</span>
                {row.providerId && <span className="font-mono">{row.providerId.slice(0, 8)}…</span>}
              </p>

              {row.error && (
                <p className="mt-2 rounded-xl nm-inset px-3 py-2 font-mono text-[11px] leading-relaxed text-brand-300">
                  {row.error}
                </p>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
